import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/index.css'
import { initAnalytics } from './services/AnalyticsService'

// 初始化Google Analytics
initAnalytics()

createApp(App).use(router).mount('#app')